import { FC } from "react";
import { useSelector } from "react-redux";
import { selectUserProfileImage } from "../../../../slices/user-slice";

interface ProfileImageProps {
    preview: string;
}

const ProfileImage: FC<ProfileImageProps> = (props) => {
    const profileImage = useSelector(selectUserProfileImage());

    return (
        <img
            src={props.preview || profileImage}
            alt="user"
            className="object-cover w-[160px] dmax5:w-[80px] h-[160px] dmax5:h-[80px] rounded-full"
        />
    );
};

export default ProfileImage;
